import React from "react";
import { MultiSelectGiz } from "./MultiSelectGiz";

export const SimpleSelectGiz = (props) => {
    return <MultiSelectGiz isMulti={false} {...props}/>;
}
